"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductSizeSearchModel = instanceOfProductSizeSearchModel;
exports.ProductSizeSearchModelFromJSON = ProductSizeSearchModelFromJSON;
exports.ProductSizeSearchModelFromJSONTyped = ProductSizeSearchModelFromJSONTyped;
exports.ProductSizeSearchModelToJSON = ProductSizeSearchModelToJSON;
exports.ProductSizeSearchModelToJSONTyped = ProductSizeSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductSizeSearchModel interface.
 */
function instanceOfProductSizeSearchModel(value) {
    return true;
}
function ProductSizeSearchModelFromJSON(json) {
    return ProductSizeSearchModelFromJSONTyped(json, false);
}
function ProductSizeSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'pssName': json['pssName'] == null ? undefined : json['pssName'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
    };
}
function ProductSizeSearchModelToJSON(json) {
    return ProductSizeSearchModelToJSONTyped(json, false);
}
function ProductSizeSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'pssName': value['pssName'],
        'useStatus': value['useStatus'],
    };
}
